<template>
  <div class="cx_workflow" :class="{toolbar : isToolbar}" v-if="isValid">
    <!-- <Badge :value="item.state" :list="statusList" v-if="statusList"/>    -->
    <b-button v-for="item in actions" :key="item.stateIdTo" :class="sendClass" :disabled="disabled" @click="send(item.stateIdTo,item.actionName, item)" tabindex="-1">{{item.actionName}}</b-button>
    <b-button class="cx_workflow_inactive" :disabled="backDisabled" v-if="backVisible" @click="sendBack"  tabindex="-1">差戻</b-button>
    <span v-if="isToolbar==false">{{$api.perms.getWorkflowState(item.workflowCode, item.workflowId,item.workflowStateId).name}}</span>     
    <span v-if="item.workflowHolder && (isToolbar==false)"> @{{item.workflowHolder | userGroup}}</span>
    <!-- 新規追加用ダイアログ -->
    <b-modal class="dialog" :visible="true" v-if="showDialog" title="確認メッセージ" @ok="onExecute" @hide="onHide" :no-close-on-backdrop="true" centered>
      <span>{{dialogCaption}}を実行してよろしいですか？</span>
      <TextBox title="メッセージ" :isEdit="true" :value.sync="dialogMessage" :rows="3"  />
    </b-modal>    
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Emit ,Watch} from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';
// import { WorkflowAction } from '../models/workflowAction';

@Component
export default class Workflow extends Vue {
  @Prop() public item: Common.StateObject;
  @Prop() public index: number;
  @Prop({default:false}) public isToolbar: boolean;
  @Prop({default:null}) public statusList: string;
  @Prop({ default: null }) public perm: string;
  @Prop({default: null}) public preSendAction:(item :Common.StateObject, action:Common.WorkflowAction)=>{};

  public actions: Common.WorkflowAction[] = new Array();

  showDialog:boolean = false;
  dialogCaption:string = '';
  dialogMessage:string = '';
  onExecute = ()=>{};

　public created(){
    this.actions = this.$api.perms.getWorkflowActions(this.item.workflowCode, this.item.workflowId,this.item.workflowStateId);
  }

  public get isValid():boolean{
    return this.item && (this.item instanceof Common.StateObject);
  }
  @Watch('item')
  public onItemChanged()
  {
    this.actions = this.$api.perms.getWorkflowActions(this.item.workflowCode, this.item.workflowId,this.item.workflowStateId);
    this.$forceUpdate();
  }
  //workflowIdとworkflowStatusIdにもとづいて現在のステータス・sendアクション(複数)を取得・表示する。
  //historyがある場合はsendbackアクションを表示する。


  public get sendClass(): string{
    const state = this.$api.perms.getWorkflowState(this.item.workflowCode, this.item.workflowId,this.item.workflowStateId);
    //終端点は灰色にする
    if ((state.type & Common.StateTypes.ExitStatus) == Common.StateTypes.ExitStatus) return 'cx_workflow_inactive'
    else return 'cx_workflow_active';
  }

  public get backVisible(): boolean {
    if (!this.item.workflowCode) return false;
    const state = this.$api.perms.getWorkflowState(this.item.workflowCode, this.item.workflowId,this.item.workflowStateId);
    //開始点以外でUserStatusの場合に差戻しボタンを表示する
    return (state.type & Common.StateTypes.EntryStatus) != Common.StateTypes.EntryStatus && (state.type & Common.StateTypes.UserStatus) == Common.StateTypes.UserStatus;
  }


  public get disabled(): boolean {
    //アクセス権限がない場合も非活性にする
    return this.$api.perms.hasWorkflowPermission(this.item.workflowHolder) == false || this.$api.perms.hasMenuPermission(this.perm) == false;
  }

  public get backDisabled(): boolean {
    //取戻権限を承認履歴に基づいて判定する処理をなくす=誰でも押せる
    return false;

    // //最終アクションのユーザーを取得して自分自身だった場合は、有効化(disable=false)する
    // //const matches = this.item.workflowHistory != null ? this.item.workflowHistory.match(/(?<="userId":")[^"]*(?="[^¥{]*$)/):null;
    // const matches = this.item.workflowHistory != null ? this.item.workflowHistory.match(/"userId":"[^"]*(?="[^¥{]*$)/):null;
    // const ownAction = matches != null && matches[0] == '"userId":"' + this.$api.auth.userId;
    // return (this.$api.perms.hasWorkflowPermission(this.item.workflowHolder) == false) && (ownAction == false);
  }
  public suppressClick(){
    //modalからのクリック伝搬を阻止
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
  }
  // ワークフローアクションに帳票がセットされている場合ダイアログの表示を変える
  public workflowAction: Common.WorkflowAction = null;
  public async send(stateId:number, actionName:string, action:Common.WorkflowAction) {
      if(this.preSendAction) await this.preSendAction(this.item, action);
      this.dialogCaption = actionName;      
      this.workflowAction = action;
      this.showModal(true,stateId);

      this.suppressClick();
  }
  public sendBack() {
      this.dialogCaption = '差戻';   
      this.showModal(false);
      this.suppressClick();
  }

  public getItemWithMessage(){
    if (this.dialogMessage != ''){
        const msg = new Common.WorkflowMessage();
        msg.userId = this.$api.auth.userId;
        msg.isNote = false;
        msg.destination = ''; //宛先はサーバー側で更新する
        msg.description = this.dialogMessage;
        msg.timeStamp = null; //新規メッセージをマークする
                
        // const result = new Array<Common.WorkflowMessage>();
        // if (this.item.workflowMessage){
        //   (JSON.parse(this.item.workflowMessage) as Array<any>).forEach(source => {
        //     const target = new Common.WorkflowMessage();
        //     Object.assign(target, source);
        //     result.push(target);
            
        //   });
        // }
        // result.sort((a,b)=> a.timeStamp > b.timeStamp ? -1 : 1);//降順ソート
        // result.unshift(msg);

        // this.item.workflowMessage = JSON.stringify(result);

        this.item.workflowMessage = msg;
    }

    return this.item;
  }
  public onHide(){
     this.showDialog= false;
  }

  public showModal(isSend:boolean, stateId :number = 0){
        let componentClass = Vue.extend(Components.WorkflowDialog);
        var router = this.$router;
        let instance = new componentClass({
            router,
            propsData: {
              dialogCaption :this.dialogCaption,
              isSend :isSend,
              item: this.item,
              stateId: stateId,
              workflowAction: this.workflowAction,
              onUpdate:  (obj:any) => {       
                  this.$emit('updated',this.index, obj);  //ダイアログが先に閉じるためイベント処理できない   
              }
            },
          });
        //テナント設定のワークフロー確認画面表示フラグがオフで、メール送信設定がない場合は実行処理を直接呼出し、確認画面の表示を省略する
        if (this.$api.tenantSettings && this.$api.tenantSettings.showWorkflowConfirm == false &&  (this.workflowAction && this.workflowAction.isShowSendReport == false)) {
          (instance as Components.WorkflowDialog).onExecute(null);
          return;
        }

        instance.$mount();
        instance.$on('hidden', () => {       
          //destroyできない
          instance.$el.parentElement.removeChild(instance.$el);
          instance.$destroy();
        });
        this.$root.$el.appendChild(instance.$el);        //ルートにマップする
  }
}
</script>
<style lang="scss">
.cx_workflow{
    font-size: 11px;
    white-space:nowrap;
    overflow-x:hidden;
    > span {
    margin-top: 3px;
    margin-left:3px;
    display: inline-block;
    vertical-align: middle;
    }
    .modal-body{
      span{
      text-align: left;
      }

    }
    &.toolbar {
      >button {
        font-size: 14px;        
        padding: 4px 15px 4px 15px;
        margin : 3px 5px 1px 5px;
        border-radius: 5px;        
        min-width: 110px;
      }
    }
    > button {
        font-size: 11px;
        padding: 1px 7px 1px 7px;
        margin : 1px 5px 1px 0px; //一覧でsticky部分のボーダーが消えるため調整
        border-radius: 4px;
        font-weight: 500;
        &.cx_workflow_active{
            background-color : green;
             border-color: green;
            &:hover{
              background-color : rgb(89, 165, 2);
            }

            &:disabled{
              background-color : lightgray;
              border-color: lightgray;
              &:hover{
                background-color : lightgray;
              }
            }
        }
        &.cx_workflow_inactive{
            background-color : gray;
            border-color: gray;

            
            &:hover{
              background-color : darkgray;
            }

            &:disabled{
              background-color : lightgray;
              border-color: lightgray;
              &:hover{
                background-color : lightgray;
              }
            }
        }
    }

    .modal-dialog {
      width:400px;

      .cx_spmode & {
        margin:0px auto;
        width: 100%;
        justify-content: center;
        
        .modal-content{
          max-width: 400px;
        }
      }
      span {
        font-size: 14px;
        margin-bottom:10px;
        display: block;
      }

    }
}
</style>